import { AssignedIncidents } from "@/features/home/assigned-incidents";

export const Route = createFileRoute({
  component: AssignedIncidents,
});
